import { createBrowserRouter } from "react-router-dom";
import App from '../App'
import AdminPanel from '../pages/AdminPanel'
import AllEvents from "../pages/AllEvents";
import Dashboard from "../pages/Dashboard";
import ContactReport from "../pages/ContactReport";
import AdmissionReport from '../pages/AdmissionReport'
import NewsPanel from "../pages/NewsPanel";
import AdminLogin from "../pages/AdminLogin";
import AllStudents from "../components/Student/AllStudents";
import StudentDetails from "../components/Student/StudentDetails";
import Calendar from "../pages/Calendar";
import StudentDashboard from "../components/Dashboard/StudentDashboard";
import StuAdmissionForm from "../components/Student/StuAdmissionForm";
import Addparent from "../components/Parent/Addparent";
import Allclass from "../components/Class/allclass";
import Addclass from "../components/Class/addclass";
import AddSection from "../components/Section/AddSection";
import AllSection from "../components/Section/AllSection";
import Subjects from "../components/Subject/Subjects";
import AllDepartments from "../components/Department/AllDepartments";
import AddDepartment from "../components/Department/AddDepartment";
import AllCourses from "../components/Course/AllCourses";
import AddCourses from "../components/Course/AddCourses";
import AllNotifications from "../components/Notifications/AllNotifications";
import AllProfessor from "../components/Professor/AllProfessor";
import AddProfessor from "../components/Professor/AddProfessor";
import CreateNotifications from "../components/Notifications/CreateNotifications";
const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            { path: "/admin-login", element: <AdminLogin /> },
            {
                path: "/", element: <AdminPanel />,
                children: [
                    { path: "dashboard", element: <Dashboard /> },
                    { path: "all-events", element: <AllEvents /> },
                    { path: "contact-report", element: <ContactReport /> },
                    { path: "admission-report", element: <AdmissionReport /> },
                    { path: "newspanel", element: <NewsPanel /> },
                    { path: "allStudents", element: <AllStudents /> },
                    { path: "studentDetails", element: <StudentDetails /> },
                    { path: "stuadmissionForm", element: <StuAdmissionForm /> },
                    { path: "calendar", element: <Calendar /> },
                    { path: "studentdashboard", element: <StudentDashboard /> },
                    { path: "addparent", element: <Addparent /> },
                    { path: "allclass", element: <Allclass /> },
                    { path: "addclass", element: <Addclass /> },
                    { path: "addsection", element: <AddSection /> },    
                    { path: "allsection", element: <AllSection /> },
                    { path: "subjects", element: <Subjects /> },
                    { path: "alldepartments", element: <AllDepartments /> },
                    { path: "adddepartment", element: <AddDepartment /> },
                    { path: "allcourses", element: <AllCourses /> },
                    { path: "addcourses", element: <AddCourses /> },
                    {path:"allNotifications", element:<AllNotifications/>},
                    {path:"allProfessor", element:<AllProfessor/>},
                    {path:"addProfessor", element:<AddProfessor/>},
                    {path:"addNotifications", element:<CreateNotifications/>},
                ]
            },
        ]
    }]);
export default router;






